(() => {
  'use strict';

  const script = document.currentScript;
  const shopify = window.Shopify;
  if (!script || window.__rdbWhatsAppTrackingInstalled) return;
  if (shopify?.designMode || shopify?.inspectMode) return;

  const allowPreview = script.dataset.allowPreview === 'true';
  const previewRequest = new URL(window.location.href).searchParams.has('preview_theme_id');
  if (!allowPreview && (shopify?.theme?.role !== 'main' || previewRequest)) return;

  const ga4Id = script.dataset.ga4Id === 'G-KJWM852VQE' ? script.dataset.ga4Id : '';
  const adsSendTo = /^AW-18415127100\/[A-Za-z0-9_-]{6,128}$/.test(script.dataset.adsSendTo || '')
    ? script.dataset.adsSendTo
    : '';
  if (!ga4Id && !adsSendTo) return;

  const pageTypes = new Set(['index', 'product', 'collection', 'list-collections', 'page', 'blog', 'article', 'search', 'cart', 'policy', '404']);
  const pageType = pageTypes.has(script.dataset.pageType) ? script.dataset.pageType : 'other';
  const locale = /^(en|ar)$/i.test(script.dataset.storefrontLocale || '')
    ? script.dataset.storefrontLocale.toLowerCase()
    : 'other';
  const productId = pageType === 'product' && /^\d{1,20}$/.test(script.dataset.productId || '')
    ? script.dataset.productId
    : '';
  const handledEvents = new WeakSet();

  const hasConsent = (method) => {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      return typeof privacy?.[method] === 'function' && privacy[method]() === true;
    } catch {
      return false;
    }
  };

  const approvedDomain = (anchor) => {
    try {
      const url = new URL(anchor.href, window.location.href);
      if (url.protocol !== 'https:' || url.username || url.password || url.port) return '';
      if (url.hostname === 'wa.me' && /^\/971565440082\/?$/.test(url.pathname)) return 'wa.me';
      if (url.hostname !== 'api.whatsapp.com' || !/^\/send\/?$/.test(url.pathname)) return '';
      const phoneValues = url.searchParams.getAll('phone');
      if (phoneValues.length !== 1 || !/^[+\d\s()-]+$/.test(phoneValues[0])) return '';
      return phoneValues[0].replace(/\D/g, '') === '971565440082' ? 'api.whatsapp.com' : '';
    } catch {
      return '';
    }
  };

  const buttonLocation = (anchor) => {
    if (anchor.matches('.d2-bottom-nav__whatsapp')) return 'mobile_dock';
    if (anchor.matches('.d2-desktop-chat')) return 'desktop_floating';
    if (anchor.matches('.d2-whatsapp-sheet__continue')) return 'confirmation';
    if (anchor.matches('.ral__whatsapp')) return 'ads_hero';
    if (anchor.matches('.rdb-linked-page__button')) return 'linked_page';
    if (anchor.closest('footer, [data-rdb-footer]')) return 'footer';
    if (anchor.closest('.d2-desktop-nav')) return 'desktop_menu';
    if (anchor.closest('[data-rp-menu], .rdb-nav-dialog, nav, header')) return 'menu';
    return 'content';
  };

  const send = (name, parameters) => {
    try {
      window.gtag('event', name, parameters);
    } catch {
      return;
    }
  };

  const onActivation = (event) => {
    if (!event.isTrusted || event.defaultPrevented || handledEvents.has(event)) return;
    if (event.type === 'click' && event.button !== 0) return;
    if (event.type === 'auxclick' && event.button !== 1) return;
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    const anchor = target?.closest('a[href]');
    if (!anchor || anchor.closest('[data-d2-nav-open]') || anchor.hasAttribute('download')) return;
    const linkDomain = approvedDomain(anchor);
    if (!linkDomain || typeof window.gtag !== 'function') return;

    handledEvents.add(event);
    if (ga4Id && hasConsent('analyticsProcessingAllowed')) {
      const parameters = {
        send_to: ga4Id,
        transport_type: 'beacon',
        button_location: buttonLocation(anchor),
        page_type: pageType,
        storefront_locale: locale,
        link_domain: linkDomain,
      };
      if (productId) parameters.product_id = productId;
      send('whatsapp_click', parameters);
    }
    if (adsSendTo && hasConsent('marketingAllowed')) {
      send('conversion', { send_to: adsSendTo, transport_type: 'beacon' });
    }
  };

  window.__rdbWhatsAppTrackingInstalled = true;
  window.addEventListener('click', onActivation, { passive: true });
  window.addEventListener('auxclick', onActivation, { passive: true });
})();
